
import { Label } from "devextreme-react/data-grid";
import Form, { GroupItem, SimpleItem } from "devextreme-react/form"
import React, { forwardRef, useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { FileUploader } from "../../components";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { Category } from "../account/detail/tabs/product/type";
import { RequestSlider } from "./type"

const createSliderForm = forwardRef<any, { data: RequestSlider }>(
    ({ data }, ref) => {
        const localize = useSelector(getLocalized);
        const [categories, setCategories] = useState<Category[]>([]);
        const { token, lang } = useSelector(getApiParams);

        const getCategories = useCallback((async () => {
            const response: ApiResponse<Category[]> = await createRequest({
                method: "GET",
                url: "/api/dashboardview/categories",
                bodyType: BodyType.formdata,
                token,
                body: {},
                lang,
            });
            if (verfiyResponse(response)) {
                setCategories(response.Result)
            }
        }), [token, lang])

        useEffect(() => {
            getCategories()
        }, [getCategories])
        return (
            <form>
                <Form
                    ref={ref}
                    key="id"
                    labelLocation="left"
                    formData={data}
                    showColonAfterLabel={true}
                    validationGroup='createSliderFrom'
                >
                    <GroupItem>
                        <SimpleItem
                            dataField="Title"
                            label={{
                                text : localize.getString("title")
                            }}
                            editorType={"dxTextBox"}
                            editorOptions={{
                                inputAttr: {
                                    style: " text-transform: capitalize",
                                },
                            }}
                        />
                        <SimpleItem
                            dataField="Description"
                            editorType={"dxTextBox"}
                            label={{
                                text : localize.getString("description")
                            }}
                            editorOptions={{
                                inputAttr: {
                                    style: " text-transform: capitalize",
                                },
                            }}
                        />
                        <SimpleItem
                            dataField="Message"
                            editorType={"dxTextBox"}
                            label={{
                                text : localize.getString("message")
                            }}
                            editorOptions={{
                                inputAttr: {
                                    style: " text-transform: capitalize",
                                },
                            }}
                        />
                        <SimpleItem
                            dataField="Link"
                            editorType={"dxTextBox"}
                            label={{
                                text : localize.getString("link")
                            }}
                            editorOptions={{
                                inputAttr: {
                                    style: " text-transform: capitalize",
                                },
                            }}
                        />
                        <SimpleItem
                            dataField="File"
                        >
                            <FileUploader
                                buttonText={localize.getString("selectFile")}
                                onValueChanged={(values) => {
                                    console.log(values[0]);
                                    (data.File = values[0])
                                }}
                            />
                            <Label text={localize.getString("file")}></Label>
                        </SimpleItem>
                        <SimpleItem
                            dataField={`ProductCategoryId`}
                            label={{
                                text: localize.getString("category"),
                            }}
                            editorType={"dxLookup"}
                            editorOptions={
                                {
                                    searchEnabled: true,
                                    items: categories,
                                    displayExpr: "Name",
                                    valueExpr: "Id",
                                }
                            }
                        >

                        </SimpleItem>
                    </GroupItem>

                </Form>
            </form>
        )
    }
)

export default createSliderForm